import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TabsTagsDesktop as TabsTags } from '@alfa-bank/site-tabs/tabs-tags-desktop';
import { Tab } from '@alfa-bank/site-tabs/tab';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';
import { PilOfferCardDesktop as PilOfferCard } from '@alfa-bank/site-pil-offer-card/desktop';
import { PersonalizationProvider } from '@alfa-bank/site-personalization-provider';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { PilSamuraiCalculatorDesktop as PilSamuraiCalculator } from '@alfa-bank/site-pil-samurai-calculator/desktop';
import { Publisher } from '@alfa-bank/site-event-bus/publisher';
import { Subscriber } from '@alfa-bank/site-event-bus/subscriber';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { publish } from '@alfa-bank/site-event-bus';
import { AnalyticsEventSenderOnMount } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender-on-mount';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { CalculatorWithModalDesktop as CalculatorWithModal } from '../components/calculator-with-modal/desktop';
import { getCardStylerDesktop as getCardStyler } from '../config';
import { PilPreparedCreditOffers as Component } from '../pil-prepared-credit-offers';
import type { IDeps, TPilPreparedCreditOffers } from '../models';

import styles from './desktop.css';

export const PilPreparedCreditOffersDesktop = createWidget<IDeps, TPilPreparedCreditOffers>({
    Aligner,
    AnalyticsEventSenderOnMount,
    Button,
    CalculatorWithModal,
    getCardStyler,
    styles,
    NamedContainer,
    Publisher,
    Subscriber,
    publish,
    PersonalizationProvider,
    PilOfferCard,
    PilSamuraiCalculator,
    sendEvent,
    TabsTags,
    Tab,
    Text,
    useNamedContainersWithChildren,
    showMore: false,
    notificationTitleNewLine: true,
})(Component);
